import React, {useCallback, useEffect, useState} from "react";
import {deleteUser, getRoles, updateUser} from "../../../../service/adminService";
import {Button, ButtonToolbar, Form, Modal, SelectPicker, Stack} from "rsuite";
import {updateUserModel} from "../../../form/models";
import {getClearances} from "../../../../service/dataService";

const EditUserModal = (props) => {
    const { open, handleClose, selectedUser } = props

    const [localState, setLocalState] = useState();
    const [roles, setRoles] = useState([]);
    const [clearances, setClearances] = useState([]);

    useEffect(() => {
        setLocalState({...selectedUser});
    }, [selectedUser]);

    useEffect(() => {
        getRoles().then((roles) => {
            setRoles(roles.map(ele => ({label: ele.roleName, value: ele.roleName})));
        });
        getClearances().then((data) => {
                // format the data into InputPicker format for now
                setClearances(data.map(ele => ({label: ele.clearanceName, value: ele.clearanceName})));
            }
        );
    }, []);

    const submitUserEdit = (isFormValid) => {
        if(!isFormValid) return;
        updateUser(localState).then((response) => {
            handleClose(response);
            setLocalState({});
        });
    };

    const submitUserDelete = useCallback(() => {
        deleteUser({id: localState.id}).then((response) => {
            handleClose(response);
        });
    }, [handleClose, localState]);

    // rsuite does not have an onSubmit, we must handle state changes per controlled field
    const handleFormChange = (event) => {
        setLocalState({...localState, ...event});
    }

    return (
        <Modal
            open={open}
            onClose={handleClose}
            backdrop="static"
        >
            <Modal.Header>
                <Modal.Title>Add User</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Stack spacing={2} direction='column' alignItems='flex-start'>
                    <p>
                        <b>Warning:</b> Modifying a user's email address may render them unable to login.
                    </p>
                    <p>
                        Deleting a user will remove all associated resume data. Proceed with caution.
                    </p>
                </Stack>
            </Modal.Body>
            <Form
                layout="vertical"
                model={updateUserModel}
                onChange={handleFormChange}
                onSubmit={submitUserEdit}
                formDefaultValue={selectedUser}
                fluid
            >
                <Form.Group>
                    <Form.ControlLabel>Email</Form.ControlLabel>
                    <Form.Control name="email"/>
                </Form.Group>
                <Form.Group>
                    <Form.ControlLabel>First Name</Form.ControlLabel>
                    <Form.Control name="firstName"/>
                </Form.Group>
                <Form.Group>
                    <Form.ControlLabel>Last Name</Form.ControlLabel>
                    <Form.Control name="lastName"/>
                </Form.Group>
                <Form.Group>
                    <Form.ControlLabel>Role</Form.ControlLabel>
                    <Form.Control name="role"
                                  accepter={SelectPicker}
                                  data={roles}
                    />
                </Form.Group>
                <Form.Group controlId="clearance">
                    <Form.ControlLabel>Clearance</Form.ControlLabel>
                    <Form.Control name="clearance"
                                  accepter={SelectPicker}
                                  data={clearances}
                    />
                </Form.Group>
                <Form.Group>
                    <ButtonToolbar>
                        <Button type="submit" appearance="primary">
                            Ok
                        </Button>
                        <Button onClick={handleClose} appearance="default">
                            Cancel
                        </Button>
                        <Button onClick={submitUserDelete} appearance="primary" color="red">
                            Delete User
                        </Button>
                    </ButtonToolbar>
                </Form.Group>
            </Form>
        </Modal>
    );
};

export default EditUserModal;